import { render, staticRenderFns } from "./NextTag.template.vue?vue&type=template&id=a49511f2&scoped=true&"
var script = {}
import style0 from "./NextTag.template.vue?vue&type=style&index=0&id=a49511f2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49511f2",
  null
  
)

export default component.exports